export class AgrimotorAddress {
    line1: string = '';
    line2: string = '';
    line3: string = '';
    town: string = '';
    county: string = '';
    postcode: string = '';
}
